<template>
  <div class="user">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>管理员列表</h1>
        <div class="input-flex">
          <el-button
            type="primary"
            size="small"
            @click="addAdmin"
            v-if="userinfo.is_super == 1"
            >添加管理员</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :max-height="scrollHeight"
      >
        <el-table-column fixed prop="id" label="ID"></el-table-column>
        <el-table-column fixed prop="account" label="用户名"></el-table-column>
        <el-table-column fixed prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1">正常</el-tag>
            <el-tag v-else type="info">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="small" @click="setRow(scope.row)" type="primary"
              >设置</el-button
            >
            <el-button
              size="small"
              @click="setPassword(scope.row)"
              type="success"
              >修改密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 对话框 -->
    <el-dialog title="头像" :visible.sync="dialogVisibleImg" width="50%">
      <el-image class="show-image" :src="showImgUrl" fit="cover"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleImg = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <!-- 设置管理员信息 -->
    <el-dialog title="设置管理员状态" :visible.sync="dialogVisible">
      <el-form
        :model="setAdminForm"
        :rules="setAdminRules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="管理员用户名" prop="account">
          <el-input
            v-model="setAdminForm.account"
            placeholder="请输入管理员用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员状态" prop="status">
          <el-select
            v-model="setAdminForm.status"
            placeholder="管理员状态"
            style="width:100%;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSetRow('ruleForm')"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 新增管理员 -->
    <el-dialog title="新增管理员" :visible.sync="dialogVisibleAdd">
      <el-form
        :model="addAdminForm"
        :rules="addAdminRules"
        ref="ruleForm1"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="管理员用户名" prop="account">
          <el-input
            v-model="addAdminForm.account"
            placeholder="请输入管理员用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="password">
          <el-input
            v-model="addAdminForm.password"
            type="password"
            placeholder="请输入管理员密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员状态" prop="status">
          <el-select
            v-model="addAdminForm.status"
            placeholder="管理员状态"
            style="width:100%;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddRow('ruleForm1')"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 设置管理员密码 -->
    <el-dialog title="设置管理员密码" :visible.sync="dialogVisiblePassword">
      <el-form
        :model="setPasswordForm"
        :rules="setAdminPasswordRules"
        label-width="120px"
        ref="ruleForm2"
        class="demo-ruleForm"
      >
        <el-form-item label="管理员密码" prop="password">
          <el-input
            v-model.trim="setPasswordForm.password"
            type="password"
            placeholder="请输入管理员密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePassword = false">取 消</el-button>
        <el-button type="primary" @click="confirmSetPassword('ruleForm2')"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminList, saveAdminInfo, changePwd } from "@/api/admin";
import { register } from "@/api/login";
export default {
  name: "user",
  data() {
    return {
      tableData: [], // 数据列表
      scrollHeight: 100, // 内容高度
      total: 0, // 数据总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 单页数量
      keyword: "", // 搜索关键词
      dialogVisibleImg: false, // 图片预览对话框
      showImgUrl: "", // 图片预览地址
      dialogVisible: false, // 对话框
      dialogVisibleAdd: false,
      dialogVisiblePassword: false, // 设置管理员密码对话框
      setAdminForm: {
        // 表单
        id: 0,
        account: "",
        status: "",
      },
      addAdminForm: {
        account: "",
        password: "",
        status: "",
      },
      setPasswordForm: {
        id: 0,
        password: "",
      },
      options: [
        {
          value: 1,
          label: "正常",
        },
        {
          value: 2,
          label: "禁用",
        },
      ],
      setAdminRules: {
        account: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        status: [
          { required: true, message: "请设置管理员状态", trigger: "change" },
        ],
      },
      addAdminRules: {
        account: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码字数在6~20位数", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请设置管理员状态", trigger: "change" },
        ],
      },
      setAdminPasswordRules: {
        password: [
          { required: true, message: "请输入管理员密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码字数在6~20位数", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    // keyword(key) {
    //   debounce(() => {
    //   }, 800);
    // }
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  computed: {
    userinfo() {
      return this.$store.getters.userinfo;
    },
  },
  mounted() {
    this.getData();
    this.$nextTick(() => {
      this.scrollHeight = document.body.clientHeight - 290;
    });
  },
  methods: {
    /**
     * 获取列表数据
     */
    getData() {
      adminList({
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.list;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 设置项
     * @param {object} row - 列表项
     */
    setRow(row) {
      this.setAdminForm = {
        id: row.id,
        status: row.status,
        account: row.account,
      };
      this.dialogVisible = true;
    },
    /**
     * 确认设置
     * @param {string} formName - rule校验绑定的表单名称
     */
    confirmSetRow(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("fullscreenLoading", true);
          saveAdminInfo(this.setAdminForm).then((res) => {
            if (res.data == true) {
              this.getData();
              this.dialogVisible = false;
              this.$message.success("设置成功!");
            } else {
              this.dialogVisible = false;
              this.$message.error(res.data);
              this.$store.dispatch("fullscreenLoading", false);
            }
          });
        } else {
          this.$message.error("设置内容有误");
          return false;
        }
      });
    },
    /**
     * 修改管理员密码
     * @param {object} row - 列表项
     */
    setPassword(row) {
      this.setPasswordForm = {
        id: row.id,
        password: "",
      };
      this.dialogVisiblePassword = true;
    },
    /**
     * 确认修改管理员密码
     * @param {string} formName - rule校验绑定的表单名称
     */
    confirmSetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("fullscreenLoading", true);
          changePwd(this.setPasswordForm).then((res) => {
            if (res.data == true) {
              this.$message.success("设置成功!");
              this.dialogVisiblePassword = false;
              this.$store.dispatch("fullscreenLoading", false);
            } else {
              this.$message.error(res.data);
            }
          });
        } else {
          this.$message.error("设置内容有误");
          return false;
        }
      });
    },
    /**
     * 查看图片
     * @param {string} url - 图片路径
     */
    showImg(url) {
      this.showImgUrl = url;
      this.dialogVisibleImg = true;
    },
    /**
     * 改变单页数量
     * @param {number} val - 选中的单页数量
     */
    handleSizeChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.pageSize = val;
      this.getData();
    },
    /**
     * 改变当前页面
     * @param {number} val - 选中的页面
     */
    handleCurrentChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.currentPage = val;
      this.getData();
    },
    /**
     * 添加管理员
     */
    addAdmin() {
      this.dialogVisibleAdd = true;
    },
    /**
     * 确认添加管理员
     * @param {string} formName - rule校验绑定的表单名称
     */
    confirmAddRow(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("fullscreenLoading", true);
          register(this.addAdminForm).then(() => {
            this.dialogVisibleAdd = false;
            this.$message.success("添加成功");
            this.addAdminForm = {
              account: "",
              password: "",
              status: "",
            };
            this.getData();
          });
        } else {
          this.$message.error("输入内容有误");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped src="./style/index.css"></style>
